export default function Go_Formatting_Verbs () {
  return (
    <div>
      <h1>Go_Formatting_Verbs </h1>
      <p>Formatting Verbs</p>
    </div>
  );
}